import React from 'react';
import { Box, Card, CardContent, Typography, Link, CardMedia, List, ListItem, ListItemText } from '@mui/material';
import { Container } from '@mui/material';
import harryPhoto from './StudentPhotos/photo.jpeg'

function StudentCard({ student }) {
  const { name, occupation, website, photo, interests, contactInfo } = student;

  return (
    <Card sx={{ display: 'flex', margin: 'auto', mt: 5, alignItems: 'start' ,  backgroundColor: "#fcfbfd"}}>
      {photo && (
        <CardMedia
          component="img"
          sx={{ width: 151, height: 'auto' }} // Adjust the width as needed
          image={photo}
          alt={name}
        />
      )}
      <Box sx={{ display: 'flex', flexDirection: 'column', ml: 2 }}> {/* Added margin-left here */}
        <CardContent sx={{ flex: '1 0 auto' }}>
          <Typography gutterBottom variant="h5" component="div" align="left">
            {name}
          </Typography>
          <Typography variant="subtitle1" color="text.secondary" align="left">
            {occupation}
          </Typography>
          {website && (
          <Typography variant="body1" align="left">
            Website: <Link href={website} target="_blank">{website}</Link>
          </Typography>)}
          {interests && (<Box sx={{pt: 2, pb: 1}}>
            <Typography variant="body1" component="div" align="left">
              Interests:
            </Typography>
            <List sx={{pt: 0, pb: 0, m: 0}}>
              {interests.map((interest, index) => (
                  <ListItem key={index} sx={{p: 0, pl: 1}}> {/* Padding left added here */}
                    <ListItemText primary={interest}
                                  primaryTypographyProps={{variant: 'body2'}}/> {/* Smaller text variant */}
                  </ListItem>
              ))}
            </List>
          </Box>)}
          {contactInfo && (<Typography variant="body1" align="left">
            Contact: {contactInfo}
          </Typography>)}
        </CardContent>
      </Box>
    </Card>
  );
}



function StudentPage() {
  const studentData = {
    name: "Cheng-Hao Fu",
    occupation: "PhD Student",
    website: "https://cs-people.bu.edu/chenghao/",
    photo: harryPhoto,
    interests: ["Algorithms", "Fine Grained Complexity", "Graphs"],
    contactInfo: "chenghao@bu.edu"
  };

  return (
    <Container>
      <StudentCard student={studentData} />
    </Container>
  );
}

export default StudentPage;
